var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2948_12483",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 23.9714,
    width: 23.9427,
    height: 24,
    transform: "rotate(-90 0 23.9714)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2948_12483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9502 12.0005C14.9502 12.1335 14.9292 12.2582 14.8872 12.3746C14.8459 12.4909 14.7752 12.599 14.6752 12.6988L10.0502 17.3127C9.86689 17.4956 9.63755 17.5828 9.36222 17.5741C9.08755 17.5661 8.85855 17.4707 8.67522 17.2878C8.49189 17.1049 8.40022 16.8721 8.40022 16.5895C8.40022 16.3068 8.49189 16.074 8.67522 15.8911L12.5752 12.0005L8.65022 8.08482C8.46689 7.90193 8.37922 7.67314 8.38722 7.39847C8.39589 7.12445 8.49189 6.896 8.67522 6.71311C8.85855 6.53021 9.09189 6.43876 9.37522 6.43876C9.65855 6.43876 9.89189 6.53021 10.0752 6.71311L14.6752 11.3021C14.7752 11.4019 14.8459 11.51 14.8872 11.6264C14.9292 11.7427 14.9502 11.8674 14.9502 12.0005Z",
    fill: "#747474"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRight);
export default __webpack_public_path__ + "static/media/ic-arrow-right.ad26732417b8599f5c9f694bee079588.svg";
export { ForwardRef as ReactComponent };